// extracted by mini-css-extract-plugin
export default {"modalWrapper":"EmbeddedModal_modalWrapper__xlOgm","modal":"EmbeddedModal_modal__NdHoo"};